<template>
  <div>
    <b-loading :active="isLoading" :is-full-page="true"></b-loading>
    <div style="margin-top: 10px; padding: 0 10px; overflow-x: hidden">

      <transition name="fade" mode="out-in">

        <!-- choose plan -->
        <div v-if="step === steps.PLAN_SELECTION" :key="0">
          <plans-selector v-if="selectedTab === 'customize'" :plan="plan"
                          @pickedplan="pickedPlan"></plans-selector>
          <bundle-selector v-if="selectedTab === 'bundles'" @pickedplan="pickedPlan"></bundle-selector>
        </div>
        <div v-else-if="step === steps.PLAN_CONFIRMATION" class="align-left" :key="1">
          <!--                    Future: {{this.$store.state.settingFuture}}-->
          <a style="display: block" @click="step = steps.PLAN_SELECTION">
            <img alt="Go Back" src="../assets/arrow-left.png" style="width: 15px; margin: 5px"
                 :style="$store.state.language === 'ar' ? 'transform: rotate(180deg)' : ''">
            {{ $t('Back') }}
          </a>
          <div style="margin: 10px 0">
            <div class="has-text-weight-bold is-size-4">{{ $t('Confirmation') }}</div>
            <div style="margin: 10px 0 20px">{{ $t('ConfirmationMsg') }} <span
                class="has-text-weight-bold">{{ $store.state.userInfo.msisdn }}</span></div>
          </div>
          <div class="zain-card">
            <ul>
              <li class="plan-item" :key="index" v-for="(item, index) in planDetailsList">
                <div class="columns is-mobile">
                  <div class="column is-2 is-paddingless has-text-centered" style="width: 12.2%;">
                    <img v-if="item.type === 'DATA'" src="../assets/wifi.png" alt="plan benefit">
                    <img v-else-if="item.type.toLowerCase().includes('international')"
                         src="../assets/int-calls.png" alt="plan benefit">
                    <img v-else-if="item.type.toLowerCase().includes('minutes')"
                         src="../assets/calls.png" alt="plan benefit">
                    <img v-else-if="item.type.toLowerCase().includes('whatsapp')"
                         src="../assets/wa.png" alt="plan benefit">
                    <img v-else-if="item.type.toLowerCase().includes('social')"
                         src="../assets/fb.png" alt="plan benefit">
                    <img v-else-if="item.type.toLowerCase().includes('youtube')"
                         src="../assets/yt.png" alt="plan benefit">
                  </div>
                  <div class="column has-text-black align-right">
                    <div style="color: black" class="float-left">{{
                        $tif(item.titleEn,
                            item.titleAr)
                      }}
                    </div>
                    <span>{{ item.isUnlimited ? $t('Unlimited') : item.value.replace('.0', '') }} {{ $tif(item.unitEn, item.unitAr) }}</span>
                    <br/>
                    <div class="align-left">
                      <small class="has-text-black"
                             v-if="item.type.toLowerCase().includes('social')">
                        {{ $t('SocialNetworks') }}
                      </small>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!--                        <pre class="has-text-black has-text-left">{{JSON.stringify(plan, null, 2)}}</pre>-->
          </div>
          <br><br><br><br><br>
        </div>
        <div v-else-if="step === steps.RESULT" :key="2">
          <a style="display: block" class="align-left" @click="$router.push('/')">
            <img alt="Go Back" src="../assets/arrow-left.png" style="width: 15px; margin: 5px"
                 :style="$store.state.language === 'ar' ? 'transform: rotate(180deg)' : ''">
            {{ $t('BackToMyPlan') }}
          </a>
          <div style="margin: 10px 0; padding: 20px 10px 10px" class="zain-card">
            <br>
            <div>
              <i v-if="resultIsSuccess" class="fa fa-check-circle fa-5x" style="color: #4c9928"></i>
              <i v-else class="fa fa-times-circle fa-5x" style="color: #cd0000"></i>
            </div>
            <br>
            <div class="has-text-black" v-if="resultIsSuccess" style="padding: 20px">
              {{
                this.$store.state.settingFuture ? $t('PlanActivationSuccessFuture') :
                    $t('PlanActivationSuccess')
              }}
              <br>
              <br>

            </div>
            <div class="has-text-black"
                 v-if="!resultIsSuccess && resultFailureReason === 'NoBalance'">
              <div style="padding: 10px">
                <p class="has-text-black">{{ $t('NoBalanceMessage1') }}</p>
                <br>
                <p class="has-text-black">{{ $t('NoBalanceMessage2') }}</p>
                <br>
              </div>
              <a :href="'https://www.kw.zain.com/en/web/quickpay?m=' + $store.state.userInfo.msisdn"
                 class="pink-btn"
                 style="margin: 20px 0 0; border: 1px solid; padding: 13px; display: block; border-radius: 5px;">
                {{ $t('RechargeNow') }}
              </a>
            </div>
            <div class="has-text-black" v-else-if="!resultIsSuccess && resultFailureReason === 'TenureLessThan30'"
                 style="padding: 20px">
              <p class="has-text-black">{{ $t('LowTenure1') }} {{ $store.state.userInfo.tenureCompletion.day }}
                {{ $t($store.state.userInfo.tenureCompletion.month) }}
                {{ $store.state.userInfo.tenureCompletion.year }}</p>
              <br>
              <p class="has-text-black">{{ $t('LowTenure2') }}</p>
              <br>
              <p class="has-text-black">{{ $t('LowTenure3') }}</p>
              <br>
              <br>
            </div>
            <div class="has-text-black" v-else-if="!resultIsSuccess" style="padding: 20px">
              {{ $t('FailureMessage') }}
              <br>
              <br>
            </div>
          </div>
        </div>
      </transition>
      <div v-if="(selectedTab === 'customize' || step === steps.PLAN_CONFIRMATION) && step !== steps.RESULT"
           class="product-bg zoomed">
        <div v-if="price < $store.state.minimumPrice" class="has-text-black align-left is-block disclaimer">
          {{ $t('PriceNotEnough1') + $store.state.minimumPrice + $t('PriceNotEnough2') }}
        </div>
        <div class="is-half align-left">
          <p>
                        <span style="color: black; font-weight: bold">
                            KD <em>{{ price }}</em>
                        </span>
            <br/>
          </p>
          <p class="product-bg-sub-text">{{ $t('PlanDuration') }}</p>
        </div>
        <div class="is-half align-right" style="padding-top: 10px">
          <a target="_blank" href="https://onelink.to/mtqgq9" class="btn right"
             :style="price < $store.state.minimumPrice? 'opacity: 0.5' :''">
            {{ $t('DownloadApp') }}
          </a>
        </div>

        <div class="tbl span">
          <div class="row span">
            <div class="col span pull-down">
              <div class="dbug">
                {{ getFooterMessage }}
              </div>

            </div>
          </div>
        </div>

        <div v-if="price >= $store.state.minimumPrice" class="has-text-black align-left is-block disclaimer">
          {{ $t('ByClicking') }} <a
            style="color: black; text-decoration: underline">{{ $t('Terms') }}</a></div>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import BLoading from "buefy/src/components/loading/Loading"
import PlansSelector from "../components/PlansSelector"
import BundleSelector from "../components/BundleSelector"

// noinspection ES6ShorthandObjectProperty
export default {
  name: "BuyLine",
  components: {
    BundleSelector,
    PlansSelector,
    BLoading
  },
  data: () => {
    return {
      plan: {},
      step: 1,
      scanDone: false,
      paddingTop: 0,
      isLoading: false,
      price: 0.000,
      selectedTab: 'customize',
      result: '',
      resultIsSuccess: false,
      resultFailureReason: '',
      settingFutureOffer: false,
      steps: {
        INTRO: 0,
        PLAN_SELECTION: 1,
        PLAN_CONFIRMATION: 2,
        RESULT: 3
      }
    }
  },
  computed: {
    planDetailsList() {
      return Object.values(this.plan).filter(value => parseFloat(value.price) > 0)
    },
    getFooterMessage() {
      if (this.price >= 8) return this.$t('FooterMessageAbove8KD')
      const remaining = 8 - this.price
      return this.$t('FooterMessageBelow8KD').replace('XX', remaining.toPrecision(2))
    }
  },
  methods: {
    selectTab(selectedTab) {
      this.selectedTab = selectedTab
    },
    pickedPlan(planInfo) {
      this.price = planInfo.total
      this.plan = planInfo.plan

      if (planInfo.goToNextStep) this.nextStep()
    },
    setDefaultPlanValues() {
      this.plan.valueGBs = this.$store.getters.getSettings().DATA[2]
      this.plan.valueMinutesOnNet = this.$store.getters.getSettings().ONNETMINUTES[2]
      this.plan.valueMinutesOffNet = this.$store.getters.getSettings().LOCALMINUTES[1]
      this.plan.valueInternationalMinutes = this.$store.getters.getSettings().INTERNATIONALMINUTES[1]
      this.plan.valueSocialMedia = this.$store.getters.getSettings().SOCIALMEDIA[0]
      this.plan.valueWhatsApp = this.$store.getters.getSettings().WHATSAPP[0]
      this.plan.valueYouTube = this.$store.getters.getSettings().YOUTUBE[0]
      this.plan.value5G = this.$store.getters.getSettings()['5G'][0]
    },
    async nextStep() {

    }
  },
  beforeMount() {
    if (this.$store.state.userInfo.hasFlexiOffer) {

      let userValueGBs = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'DATA').value
      let userValueMinutesOnNet = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'ON-NET MINUTES').value
      let userValueMinutesOffNet = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'LOCAL MINUTES').value
      let userValueInternationalMinutes = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'INTERNATIONAL MINUTES').value
      let userValueSocialMedia = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'SOCIAL MEDIA').value
      let userValueWhatsApp = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'WHATSAPP').value
      let userValueYouTube = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === 'YOUTUBE').value
      let userValue5G = this.$store.state.userInfo.currentOfferBenefits.find(y => y.type === '5G')

      if (userValue5G)
        userValue5G = userValue5G.value
      else
        userValue5G = 0

      this.plan.valueGBs = this.$store.getters.getSettings().DATA.find(x => x.value.replace('.0', '') === userValueGBs)
      this.plan.valueMinutesOnNet = this.$store.getters.getSettings().ONNETMINUTES.find(x => x.value.replace('.0', '') === userValueMinutesOnNet)
      this.plan.valueMinutesOffNet = this.$store.getters.getSettings().LOCALMINUTES.find(x => x.value.replace('.0', '') === userValueMinutesOffNet)
      this.plan.valueInternationalMinutes = this.$store.getters.getSettings().INTERNATIONALMINUTES.find(x => x.value.replace('.0', '') === userValueInternationalMinutes)
      this.plan.valueSocialMedia = this.$store.getters.getSettings().SOCIALMEDIA.find(x => x.value.replace('.0', '') === userValueSocialMedia)
      this.plan.valueWhatsApp = this.$store.getters.getSettings().WHATSAPP.find(x => x.value.replace('.0', '') === userValueWhatsApp)
      this.plan.valueYouTube = this.$store.getters.getSettings().YOUTUBE.find(x => x.value.replace('.0', '') === userValueYouTube)
      this.plan.value5G = this.$store.getters.getSettings()['5G'].find(x => x.value.replace('.0', '') === userValue5G)

      if (Object.values(this.plan).some(x => !x))
        this.setDefaultPlanValues()

    } else {
      this.setDefaultPlanValues()
    }
  }
}

</script>

<style lang="scss" scoped>

.back-btn {
  float: left;
  top: 19px;
  /*left: 0;*/
  position: relative;
}

[dir='rtl'] .back-btn {
  float: right;
}

* {
  color: white;
}

h4 {
  margin-top: 20px;
}

button {
  background-color: unset;
  border: 1px white solid;
  padding: 20px;
  color: white;
  font-weight: 600;
  width: 100px;
  margin: 0 20px 20px;
}

.selected-option {
  background: rgba(238, 238, 238, 0.27);
}

.is-half {
  display: inline-block;
  width: 50%;
  margin: 0;
  padding: 0;
  vertical-align: top;
}

.product-bg {
  height: 100px;
  background-color: #ffd500;
  color: black;
}


.product-bg em {
  display: inline-block;
  font-size: 1.7em;
  font-style: normal;
  font-weight: bold;
  margin-top: 0;
  color: black;
}

.product-bg a.btn {
  position: relative;
  right: 10px;
  color: white;
  background-color: #d12984;
  display: inline-block;
  font-size: 11pt;
  padding: 12px 0;
  text-transform: uppercase;
  width: 130px;
  text-align: center;
  border-radius: 5px;
  text-decoration: none;
  line-height: 1;
}

[dir='rtl'] .product-bg a.btn {
  right: unset;
  left: 10px;
  padding: 8px 0 13px;

}

.product-bg p {
  font-size: 0.85em;
  margin: 0;
  display: inline-block;
  line-height: 1;
  color: black;
  padding: 5px 0 0 10px;
  vertical-align: middle;
}

[dir='rtl'] .product-bg p {
  padding: 10px 10px 0 0;
}

.product-bg-sub-text {
  padding: 5px 0 0 10px !important;;
  display: block !important;
}

[dir='rtl'] .product-bg-sub-text {
  padding: 5px 10px 0 0 !important;
}

.zoomed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 30;
}

.disclaimer {
  color: black;
  opacity: 0.7;
  padding: 5px 10px 0;
  font-size: 0.80em;
  line-height: 1.2;
}

[dir='rtl'] .disclaimer {
  text-align: right;
  font-size: 0.8em;

}

.btn-inactive {
  opacity: 0.3;
}

.zain-card {
  padding: 20px;
  border-radius: 5px;
  background: white;
  color: black;
}

.plan-item {
  /*padding: 15px;*/
}

.plan-item, .plan-item span {
  color: black;
  font-size: 1.0em;
  /*text-align: left;*/

}

.plan-item span {
  font-weight: bold;
  font-size: 1.2em;
}

.plan-item:not(:last-child) {
  margin-bottom: 5px;
}

.plan-item img {
  padding-top: 7px;
  max-width: 35px;
  text-align: center;
}

.tbl {
  display: table;
  position: absolute;
  width: 100%;
  bottom: 100px;
}

.row {
  display: table-row;
}

.col {
  display: table-cell;
}

.pull-down {
  vertical-align: bottom;
}


.dbug {
  padding: 4px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  background: #D12B8A;
}


</style>
